import { useEffect, useMemo } from "react";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { base64ToBlob } from "utils/HelperFunction";
import { getAllReportProductDo } from "../../redux/slices/logic/getAllReportProductDo.slice";
import { allowedFields, jsonKeys } from "utils/HelperReportProductDo";
export var useFormReportProductDo = function(param) {
    var tableData = param.tableData, setTableData = param.setTableData;
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var reducers = {
        getAllReportProductDo: useAppSelector(function(state) {
            return state.getAllReportProductDoReducer;
        })
    };
    var isFormReportProductDoLoading = useMemo(function() {
        return reducers.getAllReportProductDo.isFetching;
    }, [
        reducers.getAllReportProductDo.isFetching
    ]);
    var handleMainSubmit = function(param) {
        var values = param.values;
        // console.log("handleMainSubmit", values);
        var formdataPayload = new FormData();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                var value = values[key];
                if (value === undefined || value === null) return "continue";
                if (key === "doc_files" && Array.isArray(value)) {
                    value.forEach(function(file) {
                        if (file.docData) {
                            var blob = base64ToBlob(file.docData);
                            formdataPayload.append(key, blob, "".concat(file.docName));
                        }
                    });
                } else if (jsonKeys.includes(key)) {
                    formdataPayload.append(key, JSON.stringify(value));
                } else if (Array.isArray(value)) {
                    value.forEach(function(item) {
                        formdataPayload.append(key, item);
                    });
                } else {
                    formdataPayload.append(key, value);
                }
            };
            for(var _iterator = allowedFields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var payload = formdataPayload;
        dispatch(getAllReportProductDo({
            payload: payload,
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    useEffect(function() {
        if (reducers.getAllReportProductDo.data && !reducers.getAllReportProductDo.isError) {
            var datas = reducers.getAllReportProductDo.data.data;
            setTableData(datas);
        }
    }, [
        reducers.getAllReportProductDo.data
    ]);
    return {
        isFormReportProductDoLoading: isFormReportProductDoLoading,
        handleMainSubmit: handleMainSubmit
    };
};
